import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import type * as models from './models'

/** TODO: explain */
export interface AtnDsTableState<
  TTypeParams extends ec.models.TypeParams.Constraint,
> {
  /**
   * Column configuration for each attribute.
   *
   * @see {@link models.config.Column}
   */
  columnConfigs: Partial<Record<string, models.config.Column<TTypeParams>>>
  /**
   * Current widths of each column. Get's updated each a time column is resized.
   */
  columnWidths: Partial<Record<string, number>>
  /**
   * Width of the widest cell for each attribute with overflow. This is needed
   * when we display overflow and we want to resize the column on double click
   * to remove all overflow placeholders.
   */
  columnMaxWidths: Partial<Record<string, number>>
  /**
   * Determines if table have creation option, or how creation should be
   * executed by callback definition
   */
  creation: models.config.Creation<TTypeParams>
  /**
   * @see {@link ec.Collection}
   */
  ec?: ec.Collection<TTypeParams>
  /**
   * Determines if column settings are currently opened up to be edited by the
   * user
   *
   * @default false
   */
  columnSettingsIsOpen?: boolean
  /**
   * Determines if we even give the user the option to open up column settings
   *
   * @default false
   */
  showColumnSettings?: boolean
  /**
   * TODO:
   *
   * @default false
   */
  showPagination?: boolean
  /**
   * TODO:
   *
   * @default false
   */
  showRowSelect?: boolean
  /**
   * @default ec.models.Target.DEFAULT
   * @see {@link ec.models.Target}
   */
  selectionTarget: ec.models.Target
  /**
   * TODO:
   *
   * @default false
   */
  isCellContentWrapped?: boolean
  /**
   * TODO:
   *
   * @default false
   */
  isEmbedded?: boolean
  /**
   * Name of the widget table.
   *
   * @default ec.Name
   */
  name: string | ec.Name
  /**
   *  The width of the table widget.
   *
   * @default 0
   */
  tableWidth: number
  /**
   *  Table horizontal scroll (if exists) position in pixels from the left edge.
   *
   * @default 0
   */
  horizontalScrollLeftOffsetPosition: number
  /** TODO:  */
  hoveredRow?: {
    // TODO:
    el: HTMLElement
    // TODO:
    rowRef: models.config.Row.Applied<TTypeParams>
  }
}
export namespace AtnDsTableState {
  export const INITIAL: Readonly<AtnDsTableState<any>> = {
    columnConfigs: {},
    columnMaxWidths: {},
    columnWidths: {},
    creation: false,
    ec: undefined,
    horizontalScrollLeftOffsetPosition: 0,
    name: 'Unknown',
    selectionTarget: ec.models.Target.DEFAULT,
    tableWidth: 0,
  }
}
